import { Toolbar, ToolbarProps } from "@mui/material";
import React from "react";

const FmToolbar: React.FC<ToolbarProps> = (props) => {
    return <Toolbar {...props}></Toolbar>;
};

export default FmToolbar;
